import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import chooseDialog from "../chooseDialog/index.vue" //选择代理商、园所弹窗
import AddressDialog from "../AddressDialog/index.vue" // 选择收货地址弹窗
import payTypeInfo from '@pages/Order/MeetOrder/components/payTypes/index.vue'; //支付方式

// 1.会销开课（开课）
export default {
    mixins: [services],
    components: {
        chooseDialog,
        AddressDialog,
        payTypeInfo,
    },
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    data() {
        return {
            num: 1,
            loading: false,
            agent: '',
            school: '',
            Hipackages: [], //Hi英语资源包94
            Artpackages: [], //艺术资源包102
            Bookpackages: [], //D2套餐英语资源包
            HipackagesStore: [], //Hi英语资源包94存储
            ArtpackagesStore: [], //艺术资源包102存储
            BookpackagesStore: [], //D2套餐英语资源包存储
            transportList: [], //寄送方式
            PayList: [], //支付方式
            form: this.getSubmitFormData(),
            SchoolConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            AddDialogVisible: false,
            showData: this.getShowData(), //弹窗传参
            pageIndex: 1,
            pageSize: 10,
            minNum: 1,
            maxNum: Infinity,
            isOpen: false, //是否开班
            isDelShow: [false],
            payList: [{}],
            PayListData: [],
            PayObject: [{
                Id: 0,
                label: "园所"
            }, {
                Id: 1,
                label: "代理商"
            }],
            StorageNum: this.getStorageNum(), // 存储D1 D2套餐的全款，分期的开课数
            packageDetails: [],
            isSchoolKaike: false,
            OldSchoolId: '', //转园存储原园所
            PackageBox: [], //存储订单详情初始化
            schoolConsignee: this.getSchoolConsignee()

        }
    },
    methods: {
        // 存储D1 D2套餐的全款，分期的开课数
        getStorageNum() {
            return cloneDeep({
                typeOneClassNumAll: '', //D1 全款可开课数
                typeOneClassNumFen: '', //D1 分期可开课数
                typeTwoClassNumAll: '', //D2 全款可开课数
                typeTwoClassNumFen: '', //D2 分期可开课数
            });
        },
        getSubmitFormData() {
            return cloneDeep({
                "OrderId": 0,
                "AgentId": 0,
                "SchoolId": 0,
                "PackageId": 599, //组合套餐
                "SchoolConsigneeId": 0,
                "SendMode": 223,
                "PayMode": 222,
                "GoodsList": [],
                "OrderPrice": 0,
                "OrderPostPrice": '', //邮费
                //支付方式
                "ListMeetPay": [],
                "PayObject": null, //支付对象
                "Remark": "",
                "ConvertNum": 0, //兑换课时数
                "ListBookDebt": [], // 欠的资源包
                "ListClassNum": [], // 开课详情


            });
        },
        // 园所地址
        getSchoolConsignee() {
            return cloneDeep({
                ConsigneeProvId: '',
                ConsigneeCityId: '',
                ConsigneeAreaId: '',
                Consignee: '',
                ConsigneeAddress: '',
                ConsigneeTel: ''
            })
        },
        // 计算配置的总资源包数
        packageTotalNum(obj) {
            let num = 0
            let len = obj.length
            for (let i = 0; i < len; i++) {
                num += obj[i].ProNum
            }
            return num
        },
        // 匹配GoodsList
        getGoodsList(obj, targetObj) {
            let num = 0
            let len = obj.length
            for (let i = 0; i < len; i++) {
                if (obj[i].ProNum > 0) {
                    targetObj.push({
                        "ProId": obj[i].ProId,
                        "ProNum": obj[i].ProNum
                    })
                }

            }
            return targetObj
        },
        //选择园所
        chooseSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.chooseDialog.show({
                    title: '选择园所',
                    AgentId: this.form.AgentId,
                    isSchoolKaike: this.isSchoolKaike //转园开课

                });

            }

        },
        // 获取组件chooseDialog 值
        getDialogList(item) {
            // 切换代理商或园所重置资源包数据
            //this.packagesD = this.getPackages();
            //this.debtPackage = 0
            this.form.PayObject = null;
            if (item.title == '选择代理商') {
                this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
                this.form.AgentId = item.Id,
                    this.school = '',
                    this.form.SchoolId = 0,
                    this.ConsigneeList = '',
                    this.ConsigneeListName = ''
            } else {
                this.school = item.SchoolName + '   ' + item.PrincipalName + '   ' + item.PhoneNo
                this.form.SchoolId = item.Id

                this.getSchoolConsigneeList(this.form.SchoolId) //点击园所之后获取默认收货地址



            }
        },
        // 开班数
        changeNum(index) {
            //console.log(index)
            // this.$nextTick(function () {
            //     console.log(this.packageDetails)
            // })

        },
        addFn() {
            this.payList.push({})
            this.isDelShow.push(true)
        },
        delPayFn(item) {
            this.payList.splice((item.index - 1), 1);

        },

        //获取选择弹窗收货地址
        getAddress(item) {
            //console.log(item)
            this.schoolConsignee.ConsigneeProvId = item.ConsigneeProvince
            this.schoolConsignee.ConsigneeCityId = item.ConsigneeCity
            this.schoolConsignee.ConsigneeAreaId = item.ConsigneeArea
            this.schoolConsignee.ConsigneeAddress = item.ConsigneeAdress
            this.schoolConsignee.Consignee = item.Consignee
            this.schoolConsignee.ConsigneeTel = item.ConsigneeTel

            this.ConsigneeList = item.ConsigneeProvinceName + '  ' + item.ConsigneeCityName + '  ' + item.ConsigneeAreaName + '  ' + item.ConsigneeAdress
            this.ConsigneeListName = item.Consignee + '  ' + item.ConsigneeTel
            //this.form.SchoolConsigneeId = 0 //代表新增
        },

        //修改园所收货地址
        changeAddress() {
            this.$nextTick(() => {
                this.$refs.AddressDialog.show({
                    SchoolId: this.form.SchoolId,
                    address: this.schoolConsignee,
                    Id: this.form.SchoolConsigneeId
                });
            })

        },
        getShowData() {
            return cloneDeep({
                SchoolId: 0,
                title: '',
                isReadOnly: false,
                PackageId: "",
                isHxOrderList: false, //会销相关页面 true
                IsTransfer: false, //转园

            });
        },
        //初始化数据
        initData() {
            this.form = this.getSubmitFormData()
            this.showData = this.getShowData()
            this.school = ""
            this.agent = ""
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.payList = [{}]
            this.Hipackages = cloneDeep(this.HipackagesStore) //Hi英语资源包94
            this.Artpackages = cloneDeep(this.ArtpackagesStore) //艺术资源包102
            this.Bookpackages = cloneDeep(this.BookpackagesStore) //D2套餐英语资源包
            this.isSchoolKaike = false
            this.schoolConsignee = this.getSchoolConsignee()
        },
        show(options) {
            this.initData();

            this.showData.title = options.title
            // 设置数据
            if (options.message) {
                console.log(options.message)
                this.form.AgentId = options.message.AgentId
                this.agent = options.message.AgentName + ' , ' + options.message.C_Name + '  ' + options.message.PhoneNo
                this.school = options.message.SchoolName
                this.form.SchoolId = options.message.SchoolId
                this.form.OrderId = options.message.OrderId //查看修改
                if (this.showData.title == '会销开课') {
                    this.AddDialogVisible = true
                }
                // 获取收货地址（园所地址）
                if (this.form.SchoolId !== 0 && this.showData.title !== '转园开课') {
                    //获取园所收货地址
                    this.getSchoolConsigneeList(this.form.SchoolId)

                }
                this.GetOpenClassInfoBySchoolId(this.form.SchoolId)

                // if (options.message.OldSchoolId !== undefined) {
                //     console.log(options.message.OldSchoolId)
                //     this.GetOpenClassInfoBySchoolId(options.message.OldSchoolId) //获取开课详情
                // } else {
                //     this.GetOpenClassInfoBySchoolId(this.form.SchoolId) //获取开课详情
                // }

            } else {
                this.AddDialogVisible = true
            }
            // 会销相关订单
            if (this.showData.title == '修改订单' || this.showData.title == '查看订单') {
                jToast.show({
                    type: "loading",
                    text: "正在加载数据，请稍后...",
                    time: -1
                });
                this.showData.isHxOrderList = true
                this.showData.isReadOnly = options.isReadOnly
                this.getList(options.message.OrderId)
                if (options.message.OldSchoolId > 0) {
                    // 转园
                    this.showData.IsTransfer = true
                } else {
                    this.showData.IsTransfer = false
                }


            } else if (this.showData.title == '转园开课') {
                // 转园开课入口
                this.form.IsTransfer = 1
                this.form.OldSchoolId = options.message.SchoolId //存储原园所  转园
                this.isSchoolKaike = true
                this.showData.isShowBtn = false
                this.school = ''
                this.AddDialogVisible = true
            }


        },
        submit() {

            this.form.OrderPrice = this.price;
            this.form.OrderPostPrice = this.postage
            this.form.GoodsList = []
            this.form.ListBookDebt = []
            // 资源包提交GoodsList
            // 欠的资源包"ListBookDebt"

            if (this.HiPackagesNum > 0) {
                // hi英语94
                this.form.Hipackages = this.Hipackages
                this.getGoodsList(this.Hipackages, this.form.GoodsList)
                let d = this.HiPackagesNum - this.HiTotalNum
                if (d > 0) {
                    this.form.ListBookDebt.push({
                        "DebtNum": d,
                        "SubjectId": 94,
                        "ProjectType": 2
                    })
                }

            }
            if (this.ArtPackagesNum > 0) {
                // 艺术102
                this.form.Artpackages = this.Artpackages
                this.getGoodsList(this.Artpackages, this.form.GoodsList)
                let d = this.ArtPackagesNum - this.ArtTotalNum
                if (d > 0) {
                    this.form.ListBookDebt.push({
                        "DebtNum": d,
                        "SubjectId": 102,
                        "ProjectType": 2
                    })
                }
            }
            if (this.BookPackagesNum > 0) {
                // 智趣坞英语94
                this.form.Bookpackages = this.Artpackages
                this.getGoodsList(this.Bookpackages, this.form.GoodsList)
                let d = this.BookPackagesNum - this.BookTotalNum
                if (d > 0) {
                    this.form.ListBookDebt.push({
                        "DebtNum": d,
                        "SubjectId": 94,
                        "ProjectType": 4
                    })
                }
            }
            // 开课详情
            this.form.ListClassNum = []
            for (let i = 0; i < this.packageDetails.length; i++) {
                if (this.packageDetails[i].ProNum > 0) {
                    if (this.packageDetails[i].PackageId == 5031) {
                        let d = this.packageDetails[i].ProNum - this.StorageNum.typeOneClassNumAll //有分期数

                        if (d > 0) {
                            // 分期和全款
                            this.form.ListClassNum.push({
                                "PackageId": this.packageDetails[i].PackageId,
                                "ClassNum": d,
                                "ChargeType": 1
                            }, {
                                "PackageId": this.packageDetails[i].PackageId,
                                "ClassNum": this.packageDetails[i].ProNum - d,
                                "ChargeType": 2
                            })
                        } else {
                            // 只有全款
                            this.form.ListClassNum.push({
                                "PackageId": this.packageDetails[i].PackageId,
                                "ClassNum": this.packageDetails[i].ProNum,
                                "ChargeType": 2
                            })
                        }
                    }
                    if (this.packageDetails[i].PackageId == 5041) {
                        let d = this.packageDetails[i].ProNum - this.StorageNum.typeTwoClassNumAll //有分期数
                        if (d > 0) {
                            this.form.ListClassNum.push({
                                "PackageId": this.packageDetails[i].PackageId,
                                "ClassNum": d,
                                "ChargeType": 1
                            }, {
                                "PackageId": this.packageDetails[i].PackageId,
                                "ClassNum": this.packageDetails[i].ProNum - d,
                                "ChargeType": 2
                            })
                        } else {
                            // 只有全款
                            this.form.ListClassNum.push({
                                "PackageId": this.packageDetails[i].PackageId,
                                "ClassNum": this.packageDetails[i].ProNum,
                                "ChargeType": 2
                            })
                        }

                    }
                    if (this.packageDetails[i].PackageId !== 5041 && this.packageDetails[i].PackageId !== 5031) {
                        this.form.ListClassNum.push({
                            "PackageId": this.packageDetails[i].PackageId,
                            "ClassNum": this.packageDetails[i].ProNum,
                            "ChargeType": 0
                        })
                    }

                }


            }

            // 判断是都选择套餐
            for (let i = 0; i < this.form.GoodsList.length; i++) {
                if (this.form.GoodsList[i].ProId == '') {
                    this.$notify({
                        title: '警告',
                        message: '请选择套餐',
                        type: 'warning'
                    });
                    return;
                }
            }
            // 支付方式
            this.form.ListMeetPay = []
            for (let i = 0; i < this.payList.length; i++) {
                // 价格为0时不需要填写支付信息
                if (this.form.OrderPrice > 0 || this.form.OrderPostPrice > 0) {
                    let data = this.$refs['payInfo' + (i + 1)][0].validate();
                    if (!data) {
                        return;
                    }
                    this.form.ListMeetPay.push(data);
                } else {
                    this.form.ListMeetPay = []
                }
            }
            let rule = [{
                name: "支付对象",
                value: this.form.PayObject,
                required: true,
            }];
            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }
            console.log(this.form)
            if (this.form.OrderId == undefined) {
                this.OpenClassApplyAdd(); //会销开课
            } else {
                this.OpenClassApplyModify() //修改
            }
        }
    },
    computed: {
        // 总课时数规则
        //(D套餐开课)80*开班数+(2017Q4会销开课)64*开班数+(D1套餐（全款))80*开班数+(D1套餐（分期))40*开班数+(D2套餐（全款))64*开班数+(D2套餐（分期))32*开班数
        //同一个套餐若同时存在的可班数中有分期又有全款，则本次开班优先消耗全款的
        //D1套餐英语兑换艺术课时数 全款16 分期8
        classTotalTime() {
            let num = 0
            if (this.packageDetails.length > 0) {
                let len = this.packageDetails.length
                let $obj = this.packageDetails
                for (let i = 0; i < len; i++) {
                    // 1012
                    if ($obj[i].ProNum > 0) {

                        if ($obj[i].PackageId == 1012) {
                            num += 80 * $obj[i].ProNum
                        }
                        // 1008
                        if ($obj[i].PackageId == 1008) {
                            num += 64 * $obj[i].ProNum
                        }
                        // 5031
                        if ($obj[i].PackageId == 5031) {
                            // D1
                            if ($obj[i].ProNum <= this.StorageNum.typeOneClassNumAll) {
                                // 全款
                                num += 80 * $obj[i].ProNum
                            } else {
                                let d = $obj[i].ProNum - this.StorageNum.typeOneClassNumAll
                                num += 80 * this.StorageNum.typeOneClassNumAll + 40 * d
                            }
                        }
                        // 5041
                        if ($obj[i].PackageId == 5041) {
                            // D2
                            if ($obj[i].ProNum <= this.StorageNum.typeTwoClassNumAll) {
                                // 全款
                                num += 64 * $obj[i].ProNum
                            } else {
                                let d = $obj[i].ProNum - this.StorageNum.typeTwoClassNumAll
                                num += 64 * this.StorageNum.typeTwoClassNumAll + 32 * d
                            }
                        }
                    }

                }
            }
            // 有兑换就扣除
            if (this.form.ConvertNum > 0) {
                num = num - this.form.ConvertNum
            }
            return num
        },
        // 可兑换课时数(没有D1时候为0，form.ConvertNum==0)
        classTimeD() {
            let num = 0
            if (this.packageDetails.length > 0) {
                let len = this.packageDetails.length
                let $obj = this.packageDetails
                for (let i = 0; i < len; i++) {
                    if ($obj[i].PackageId == 5031 && $obj[i].ProNum > 0) {
                        // D1
                        if ($obj[i].ProNum <= this.StorageNum.typeOneClassNumAll) {
                            // 全款
                            num += 16 * $obj[i].ProNum
                        } else {
                            let d = $obj[i].ProNum - this.StorageNum.typeOneClassNumAll
                            num += 16 * this.StorageNum.typeOneClassNumAll + 8 * d
                        }
                    } else if ($obj[i].PackageId == 5031 && $obj[i].ProNum <= 0) {
                        this.form.ConvertNum = 0
                    }
                }
            }
            if (this.form.ConvertNum > num) {
                // 避免开班数新增后减的情况this.form.ConvertNum > num
                this.form.ConvertNum = num
            }
            return num
        },
        step() {
            let num = 0
            if (this.packageDetails.length > 0) {
                let len = this.packageDetails.length
                let $obj = this.packageDetails
                for (let i = 0; i < len; i++) {
                    if ($obj[i].PackageId == 5031) {
                        // D1
                        if ($obj[i].ProNum <= this.StorageNum.typeOneClassNumAll) {
                            // 全款
                            num = 16
                        } else {
                            num = 8
                        }
                    }
                }
            }
            return num
        },
        // 资源包单价
        UnitPrice() {
            if (this.form.PayObject == 0) {
                // 园所88
                return 68
            } else if (this.form.PayObject == 1) {
                //代理商38
                return 38
            }
            return 0
        },
        // Hi英语总资源包套数
        HiTotalNum() {
            return this.packageTotalNum(this.Hipackages)

        },
        // 艺术
        ArtTotalNum() {
            return this.packageTotalNum(this.Artpackages)

        },
        // 智趣坞英语
        BookTotalNum() {
            return this.packageTotalNum(this.Bookpackages)

        },
        // 邮费
        postage() {
            let num = 0
            let num2 = 0
            // HI英语
            console.log(this.HiPackagesNum)
            if (this.HiTotalNum > 0 && this.HiTotalNum - this.HiPackagesNum > 0&&this.HiPackagesNum>0) {
                if (this.HiTotalNum - this.HiPackagesNum <= 30) {
                    num = 24
                } else {
                    num = ((this.HiTotalNum - this.HiPackagesNum) * 0.8).toFixed(2)
                }
            } else {
                num = 0
            }
            //智趣坞
            if (this.BookTotalNum > 0 && this.BookTotalNum - this.BookPackagesNum > 0&&this.BookPackagesNum > 0) {

                if (this.schoolConsignee.ConsigneeProvId == 131 || this.schoolConsignee.ConsigneeProvId == 132 || this.schoolConsignee.ConsigneeProvId == 133) {
                    //江浙沪地区131 132 133
                    if (this.BookTotalNum - this.BookPackagesNum <= 30) {
                        num2 = 12
                    } else {
                        num2 = ((this.BookTotalNum - this.BookPackagesNum) * 0.4).toFixed(2)
                    }
                } else {
                    // 非江浙沪地区
                    if (this.BookTotalNum - this.BookPackagesNum <= 30) {

                        num2 = 19
                    } else {
                        num2 = ((this.BookTotalNum - this.BookPackagesNum) * 0.63).toFixed(2)
                    }
                }
            } else {
                num2 = 0
            }

            return (num * 1 + num2 * 1).toFixed(2)

        },
        //订单价格
        price() {
            //【（Hi英语的总配置资源包-Hi英语总配套资源包）*88】+
            //【（艺术总配套资源包-艺术配置资源包）*282】+
            //【（智趣坞英语的总配置资源包-智趣坞英语的总配套资源包）*16.82】
            let num = 0
            // HI英语
            if (this.HiTotalNum > this.HiPackagesNum && this.HiPackagesNum > 0) {
                num += (this.HiTotalNum - this.HiPackagesNum) * this.UnitPrice
            }
            // 艺术
            if (this.ArtTotalNum > this.ArtPackagesNum && this.ArtPackagesNum > 0) {
                //console.log(2)
                num += (this.ArtTotalNum - this.ArtPackagesNum) * 282
            }
            //智趣坞
            if (this.BookTotalNum > this.BookPackagesNum && this.BookPackagesNum > 0) {

                num += (this.BookTotalNum - this.BookPackagesNum) * 17.80

            }
            return num.toFixed(2)

        },
        totalPrice() {
            return (this.price * 1 + this.postage * 1).toFixed(2)
        },
        // 至少配置Hi幼教资源包总数
        HiPackagesNum() {
            let num = 0
            if (this.packageDetails.length > 0) {
                let len = this.packageDetails.length
                let $obj = this.packageDetails
                for (let i = 0; i < len; i++) {
                    // 1012
                    if ($obj[i].PackageId == 1012 || $obj[i].PackageId == 1008 && $obj[i].ProNum > 0) {
                        num += 60 * $obj[i].ProNum
                    }
                    // 5031
                    if ($obj[i].PackageId == 5031 && $obj[i].ProNum > 0) {
                        // D1
                        if ($obj[i].ProNum <= this.StorageNum.typeOneClassNumAll) {
                            // 全款
                            num += 60 * $obj[i].ProNum
                        } else {
                            // 分期
                            let d = $obj[i].ProNum - this.StorageNum.typeOneClassNumAll
                            num += 60 * this.StorageNum.typeOneClassNumAll + 30 * d
                        }
                    }

                }
            }

            return num
        },
        // 至少配置艺术
        ArtPackagesNum() {
            let num = 0
            if (this.form.ConvertNum > 0) {

                let len = this.packageDetails.length
                let $obj = this.packageDetails

                for (let i = 0; i < len; i++) {
                    // 5031D1
                    if ($obj[i].PackageId == 5031 && $obj[i].ProNum > 0) {
                        num += (this.form.ConvertNum / 8) * 5
                    }
                }
            } else {
                this.Artpackages = cloneDeep(this.ArtpackagesStore) //艺术资源包
            }

            return num
        },
        // 智趣坞英语D2
        BookPackagesNum() {
            let num = 0
            if (this.packageDetails.length > 0) {
                let len = this.packageDetails.length
                let $obj = this.packageDetails
                for (let i = 0; i < len; i++) {
                    // 5041 D2
                    if ($obj[i].PackageId == 5041 && $obj[i].ProNum > 0) {
                        if ($obj[i].ProNum <= this.StorageNum.typeTwoClassNumAll) {
                            // 全款
                            num += 60 * $obj[i].ProNum
                        } else {
                            let d = $obj[i].ProNum - this.StorageNum.typeTwoClassNumAll
                            num += 60 * this.StorageNum.typeTwoClassNumAll + 30 * d
                        }
                    } else {
                        //this.Bookpackages = cloneDeep(this.BookpackagesStore)
                    }
                }
            }
            return num
        }

    },
    created() {
        this.getPay(8);
        this.getPay(9);
        this.getDetailsPackage(1008, 94) //hi幼教英语
        this.getDetailsPackage(5031, 102) //艺术资源包
        this.getDetailsPackage(5041, 94) //D2套餐英语资源包

    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/openClassDialog/vm.js